<template>
  <div class="modal-wrapper cvLRVf dTIQsR">
    <!--  @click="handleBackdropClick" -->
    <div class="modal-backdrop fade in"></div>
    <div class="modal">
      <div class="modal-dialog">
        <div class="modal-content" @click.stop>
          <section class="jENZOg">
            <div></div>
            <div></div>
            <div>
              <div class="close-button">
                <a @click="$emit('backToLogin')">
                  <svg class="hGsgfJ bnCywO" viewBox="0 0 32 32">
                    <path d="m6 6 20 20"></path>
                    <path d="m26 6-20 20"></path>
                  </svg>
                </a>
              </div>
            </div>
          </section>
          <div class="kkluyX">
            <div class="forgot-password-wrapper welcome-back-wrapper" style="padding: 0px">
              <div class="title">It's cool.</div>
              <div class="describe" style="padding: 0px">
                Enter your email to receive a verification code, then reset your password.
              </div>
              <div class="inputs-wrapper">
                <!-- 邮箱输入框 -->
                <div class="input-wrapper" :class="{ error: emailError }">
                  <div class="form-group">
                    <div class="">
                      <input
                        type="email"
                        v-model="email"
                        @blur="validateEmail"
                        @input="clearEmailError"
                        placeholder="Email"
                        class="form-control"
                        style="font-size: 18px"
                      />
                    </div>
                  </div>
                  <div class="input-dot"></div>
                </div>

                <!-- 验证码输入框 -->
                <div class="input-wrapper verification-wrapper" :class="{ error: codeError }">
                  <div class="form-group">
                    <div class="verification-input-group">
                      <input
                        type="text"
                        v-model="verificationCode"
                        @input="clearCodeError"
                        placeholder="Verification Code"
                        class="form-control"
                        style="font-size: 18px"
                        maxlength="6"
                      />
                      <button 
                        class="get-code-btn" 
                        :disabled="!canSendCode || countdown > 0"
                        @click="sendVerificationCode"
                      >
                        {{ countdown > 0 ? `${countdown}s` : 'Get Code' }}
                      </button>
                    </div>
                  </div>
                  <div class="input-dot"></div>
                </div>

                <!-- 新密码输入框 -->
                <div class="input-wrapper" :class="{ error: passwordError }">
                  <div class="form-group">
                    <div class="">
                      <input
                        type="password"
                        v-model="newPassword"
                        @input="clearPasswordError"
                        placeholder="New Password"
                        class="form-control"
                        style="font-size: 18px"
                      />
                    </div>
                  </div>
                  <div class="input-dot"></div>
                </div>
              </div>
              <div class="btns-wrapper" style="margin-top: 0;">
                <button 
                  class="qtvwz reset-btn" 
                  :disabled="!isFormValid" 
                  :style="isFormValid ? 'background: rgb(0, 0, 0); cursor: pointer;' : ''" 
                  @click="handleReset"
                >
                  Reset Password
                </button>
              </div>
              <div class="support-text">
                Still need help? <a style="cursor: pointer;" @click="handleTolink" class="support-link">Contact Support</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userApi } from '@/api'

export default {
  name: 'ForgotPasswordModal',
  data() {
    return {
      email: '',
      verificationCode: '',
      newPassword: '',
      emailError: false,
      codeError: false,
      passwordError: false,
      countdown: 0,
      timer: null
    }
  },
  computed: {
    isFormValid() {
      return this.email && 
             this.isValidEmail(this.email) && 
             this.verificationCode && 
             this.verificationCode.length >= 4 &&
             this.newPassword && 
             this.newPassword.length >= 6
    },
    canSendCode() {
      return this.email && this.isValidEmail(this.email)
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    handleTolink() {
      window.location.href = '#/contact'
      window.location.reload()
    },
    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },
    validateEmail() {
      if (!this.email || !this.isValidEmail(this.email)) {
        this.emailError = true
      } else {
        this.emailError = false
      }
    },
    clearEmailError() {
      if (this.email) {
        this.emailError = false
      }
    },
    clearCodeError() {
      this.codeError = false
    },
    clearPasswordError() {
      this.passwordError = false
    },
    async sendVerificationCode() {
      if (!this.canSendCode || this.countdown > 0) {
        return
      }

      try {
        // 调用发送验证码接口
        const formData = new FormData()
        formData.append('email', this.email)
        
        const response = await userApi.sendEmail(formData)
        
        if (response.code === 1) {
          this.$toast('Verification code sent to ' + this.email, 3000)
          
          // 开始倒计时
          this.countdown = 60
          this.timer = setInterval(() => {
            this.countdown--
            if (this.countdown <= 0) {
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        } else {
          this.$toast(response.msg || 'Failed to send verification code', 3000)
        }
      } catch (error) {
        console.error('Failed to send verification code:', error)
        this.$toast('Failed to send verification code, please try again', 3000)
      }
    },
    async handleReset() {
      if (!this.isFormValid) {
        return
      }

      // 验证密码长度
      if (this.newPassword.length < 6) {
        this.passwordError = true
        this.$toast('Password must be at least 6 characters', 3000)
        return
      }

      try {
        // 调用重置密码接口
        const formData = new FormData()
        formData.append('email', this.email)
        formData.append('type', 1) // 1:买家 2:卖家
        formData.append('yzm', this.verificationCode)
        formData.append('password', this.newPassword)
        
        const response = await userApi.resetPassword(formData)
        
        if (response.code === 1) {
          this.$toast('Password reset successfully!', 3000)
          
          // 清空表单
          this.email = ''
          this.verificationCode = ''
          this.newPassword = ''
          
          // 返回登录页面
          setTimeout(() => {
            this.$emit('backToLogin')
          }, 1500)
        } else {
          this.$toast(response.msg || 'Failed to reset password', 3000)
        }
      } catch (error) {
        console.error('Failed to reset password:', error)
        this.$toast('Failed to reset password, please try again', 3000)
      }
    },
    handleBackdropClick() {
      this.$emit('backToLogin')
    }
  }
}
</script>


<style scoped>
/* 验证码输入框组 */
.verification-wrapper {
  margin-top: 20px;
}

.verification-input-group {
  display: flex;
  gap: 10px;
  align-items: center;
}

.verification-input-group .form-control {
  flex: 1;
}

.get-code-btn {
  padding: 12px 20px;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s;
  min-width: 110px;
}

.get-code-btn:hover:not(:disabled) {
  background: #333;
}

.get-code-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* 输入框间距 */
.input-wrapper {
  margin-bottom: 20px;
}

.input-wrapper:first-child {
  margin-bottom: 20px;
}

/* 错误状态 */
.input-wrapper.error .form-control {
  border-color: #ff4444;
}

.input-wrapper.error .input-dot {
  background-color: #ff4444;
}

/* 移动端适配 */
@media (max-width: 767px) {
  .verification-input-group {
    flex-direction: row;
  }

  .get-code-btn {
    padding: 10px 16px;
    font-size: 13px;
    min-width: 100px;
  }

  .verification-input-group .form-control {
    font-size: 16px !important;
  }
}
</style>
